import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {catchError} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';

import {UserGuideService} from '@modules/user-guide/shared/user-guide.service';

@Component({
  selector: 'app-sign-up-modal',
  templateUrl: './sign-up-modal.component.html',
  styleUrls: ['./sign-up-modal.component.scss'],
})
export class SignUpModalComponent implements OnInit {
  signUpFormGroup: FormGroup;
  signingUp: boolean;

  constructor(
    private dialogRef: MatDialogRef<SignUpModalComponent>,
    private formBuilder: FormBuilder,
    private userGuideService: UserGuideService
  ) {}

  ngOnInit(): void {
    this.signUpFormGroup = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(50)]],
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      termsAgreed: [false, [Validators.requiredTrue]],
      productUpdates: [false, []],
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  signUp() {
    this.signingUp = true;
    const {firstName, lastName, username, password, productUpdates, termsAgreed} = this.signUpFormGroup.value;

    this.userGuideService
      .save(username, password, firstName, lastName, productUpdates, termsAgreed)
      .pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          this.signingUp = false;
          const errorMessage = JSON.parse(errorResponse.error.message);

          Object.keys(errorMessage).forEach((key: string) => {
            this.signUpFormGroup.controls[key].setErrors({
              api: [errorMessage[key]],
            });
          });

          return throwError(errorResponse);
        })
      )
      .subscribe(() => {
        this.userGuideService.showLoseEventProgressWarning = false;
        window.location.href = `${window['BASE_URL']}`;
      });
  }

  getControlError(controlName: string): string | null {
    const control: AbstractControl = this.signUpFormGroup.get(controlName);

    if (control.valid) {
      return null;
    }

    // Keep things simple by only showing API errors
    return control.errors.api;
  }
}
